// DOM utility functions

/**
 * Safely escape HTML to prevent XSS attacks
 * @param text - Text to escape
 * @returns HTML-escaped string
 */
export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Check if a value is an HTTP(S) URL or a protocol-less link starting with www.
 * @param value - string to check
 */
export function isHttpUrl(value: string): boolean {
  if (!value) return false;
  const s = value.trim();
  try {
    const url = new URL(s);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (_) {
    // Do not accept protocol-less links (e.g., www.example.com)
    return false;
  }
}
